<template>
    <v-container class="max-container">
        <v-col v-if="listOffersAvailable.length > 0" xs="12" sm="12" md="12" lg="12" class="flex-col-start">
            <!-- Ranking -->
            <div class="flex-row-start w-100" v-if="rankingEnabled">

                <v-col class="flex-col-start no-pd" cols="3" sm="2" md="2" lg="1">
                    <v-card v-for="rankingInfo in rankingMedalsGroup" :key="rankingInfo.id" elevation="0" class="card-custom" :disabled="rankingObject.ranking !== rankingInfo.name">
                        <v-card-text class="flex-col-center no-pd">
                            <v-img min-width="20px" :src="rankingInfo.medal"/>
                            <span class="vcol_vcard_cardtext__ranking--title">{{rankingInfo.name}}</span>
                            <span class="">{{rankingInfo.multiplier + 'x'}}</span>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col class="d-flex flex-auto flex-col-center no-pd" cols="9" sm="7" md="4" lg="3">
                    <span v-if="($vuetify.breakpoint.xs || $vuetify.breakpoint.sm) && expiringObject.dateExpires">
                        <strong>{{ (expiringObject.points) + (expiringObject.points == 1 ? ' ponto' : ' pontos') }} </strong> 
                        expiram no dia 
                        <strong>{{ getDateByTimeStamp(expiringObject.dateExpires) }}</strong>
                    </span>
                    <span class="vcol_span__ranking--percent">{{currentPercent + '%'}}</span>
                    <v-progress-circular size="180" :color="colorRanking" rotate="90" :value="currentPercent" width="5">
                        <div class="flex-col-center">
                            <v-img :src="currentMedal" width="38"/>

                            <div class="flex-row-start" style="margin: 10px 0px 4px 0px;">
                                <span class="progress-circular_divexp__exp">{{rankingObject.total}}</span>
                                <span class="custom--exp">EXP</span>
                            </div>
                            <span class="ranking-bond">{{rankingObject.ranking}}</span>
                            <span class="ranking-bonus">{{'Pontos ' + rankingObject.multiplier + 'x'}}</span>
                        </div>
                    </v-progress-circular>
                    <v-btn text class="text-none custom-btn" color="#EE5D09" @click="openRankingDetail()">Saiba mais</v-btn>
                    <span v-if="rankingObject && rankingObject.expiringValue"><strong>{{rankingObject.expiringValue + ' EXP'}}</strong> expiram no dia <strong>{{getDateByTimeStamp(rankingObject.dateExpires)}}</strong></span>
                </v-col>
            </div>
            <!-- = -->
            <v-col xs="12" sm="12" md="12" lg="12" xl="12" class="flex-col-start no-pd-l">
                <div class=" flex-row-start">
                    <h2> Opções de resgate</h2>
                    <div class="flex-col-start" v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm">
                        <span :style="{'color': currentCompany.primaryColor}" class="vcol_div__numberofpoints">
                            {{ ( currentCompany.remainingPoints ) +  (currentCompany.remainingPoints == 1 ? ' ponto' : ' pontos')}}
                        </span>
                        <span v-if="expiringObject && expiringObject.dateExpires" style="padding-left: 10px">
                            <strong>{{ (expiringObject.points) + (expiringObject.points == 1 ? ' ponto' : ' pontos') }} </strong> 
                            expiram no dia 
                            <strong>{{ getDateByTimeStamp(expiringObject.dateExpires) }}</strong>
                        </span>
                    </div>                     
                </div>
                <!--Mobile-->
                <div v-show="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs" class="cards-div" style="overflow: auto;">
                    <v-card max-width="200" min-width="200" hover class="shop-card" v-for="(voucher) of listOffersAvailable" :key="voucher.id">
                        <div 
                          class="voucher__card__image__container" 
                          :class="voucher.image && ( !voucher.discountPercent && !voucher.discountValue) ? '' : 'background-yellow'"
                        >
                            <v-img
                              contain
                              v-if=" voucher.image && ( voucher.discountPercent == null && voucher.discountValue == null ) " 
                              max-width="100%" max-height="140" 
                              :src="voucher.image" 
                            /> <!--Caso tenha imagem e seja um 'Produto'-->
                            <v-img 
                              v-if=" voucher.discountPercent !== null || voucher.discountValue !== null " 
                              max-width="50%" 
                              src="@/assets/points-program/voucher_tag.svg" 
                            /> <!--Caso seja um 'Vale compras'-->

                            <v-img 
                              v-if=" !voucher.image && ( voucher.discountPercent == null && voucher.discountValue == null ) " 
                              max-width="50%" 
                              src="@/assets/points-program/empty_produto.svg" 
                            /> <!--Caso não tenha imagem e seja um 'produto'-->
                        </div>

                        <v-card-title class="voucher__card__title">
                          <div class="text-truncate">
                            <span>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <span v-on="on"> {{voucher.name ? voucher.name : '' }}</span>
                                </template>
                                  {{voucher.name ? voucher.name : '' }}
                              </v-tooltip>
                            </span>
                          </div>
                        </v-card-title>
                        <v-card-subtitle class="no-pd-b">
                            {{ voucher.pointsToRedeem ? voucher.pointsToRedeem : 0 }} <span> pontos </span>
                        </v-card-subtitle>
                        <v-card-actions class="flex-row-start">
                            <v-btn text class="text-none" @click="rescueRoutine( voucher )"> <span :style="{'color': currentCompany.buttonsColor }"> Resgatar </span> </v-btn>
                        </v-card-actions>
                    </v-card>
                </div>
                <!--Desktop-->
                <v-slide-group 
                    v-show="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                    show-arrows
                    class="vcol__vslidegroup"
                >
                    <v-slide-item v-for="(voucher) of listOffersAvailable" :key="voucher.id">
                        <v-card max-width="200" min-width="200" hover class="shop-card">
                            <div 
                              class="voucher__card__image__container"
                              :class="voucher.image && ( !voucher.discountPercent && !voucher.discountValue) ? '' : 'background-yellow'"
                            >
                                <v-img
                                  contain
                                  v-if=" voucher.image && ( voucher.discountPercent == null && voucher.discountValue == null ) " 
                                  max-width="100%" 
                                  max-height="140"  
                                  :src="voucher.image" /> <!--Caso tenha imagem e seja um 'Produto'-->
                                <v-img 
                                  v-if=" voucher.discountPercent !== null || voucher.discountValue !== null " 
                                  max-width="50%" 
                                  src="@/assets/points-program/voucher_tag.svg" 
                                /> <!--Caso seja um 'Vale compras'-->

                                <v-img 
                                  v-if=" !voucher.image && ( voucher.discountPercent == null && voucher.discountValue == null ) " 
                                  max-width="50%" 
                                  src="@/assets/points-program/empty_produto.svg" 
                                /> <!--Caso não tenha imagem e seja um 'produto'-->                                             
                            </div>

                            <v-card-title class="voucher__card__title">
                              <div class="text-truncate">
                                <span>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on"> {{voucher.name ? voucher.name : '' }}</span>
                                    </template>
                                      {{voucher.name ? voucher.name : '' }}
                                  </v-tooltip>
                                </span>
                              </div>
                            </v-card-title>
                            <v-card-subtitle class="no-pd-b">
                                {{ voucher.pointsToRedeem ? voucher.pointsToRedeem : 0 }} <span> pontos </span>
                            </v-card-subtitle>
                            <v-card-actions class="flex-row-start">
                                <v-btn text class="text-none" @click="rescueRoutine( voucher )"> <span :style="{'color': currentCompany.buttonsColor }"> Resgatar </span> </v-btn>
                            </v-card-actions>
                        </v-card>   
                    </v-slide-item>
                </v-slide-group>
            </v-col>
            <v-btn :color="currentCompany.primaryColor"  class="text-none btns-bottom" @click="openConditionsModal()">
            <span style="color: white"> Consultar regras</span>
            </v-btn>
        </v-col>
        <!--Empty-->
        <v-col v-else xs="12" sm="12" md="12" lg="12" class="flex-col-center w-100 no-pd">
            <v-img class="div__emptyimg" src="@/assets/empty-views/empty_offers_2.svg"/>
        </v-col>
        
        <div v-if="rulesDialog">
            <RulesModal :dialog="rulesDialog" @closeRulesModal="rulesDialog = $event" />
        </div>

        <div v-if="rescueConfirmDialog">
            <RescueConfirmation :dialog="rescueConfirmDialog" :confirmObject="confirmObjectLocal" @closeConfirmModal="rescueConfirmDialog = $event" />
        </div>

        <div v-if="rescueInstructionDialog">
            <RescueInstruction :dialog="rescueInstructionDialog" :voucherObject="voucherObjectLocal" @rescueInstructionModalClose="rescueInstructionDialog = $event"/>
        </div>
        <div>
            <RankingDetail :dialog="rankingDetailDialog" :rankingInfo="rankingInfoLocal" @rankingDetailModalClose="rankingDetailDialog = $event"/>
        </div>
    </v-container>
</template> 

<script>
//Store
import { mapGetters } from "vuex";

//Services
import { getRankingByCompanyIdAndCurrentContactId, getExpiringPointsByCompanyIdAndCurrentContactId, getCompanyLoyaltyByCompanyId } from "@/app/components/points-program/service/points-program.service";

//Components
import RulesModal from "@/app/modals/rules-modal/rules-modal";
import RescueConfirmation from "@/app/modals/rescue-confirmation-modal/rescue-confirmation-modal";
import RescueInstruction from "@/app/modals/rescue-confirmation-modal/rescue-instruction-modal/rescue-instruction-modal.vue";
import RankingDetail from "@/app/modals/ranking-detail-modal/ranking-detail-modal";

export default {
    name: 'PointsProgram',
    components: { RulesModal, RescueConfirmation, RescueInstruction, RankingDetail },
    props: {
        listOffersAvailable: {
            type: Array
        }
    },
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        ),
        listOffersAvailableComputed() {
            return this.listOffersAvailable
        },
        rankingMedalsGroup() {
            return new Array(
                { id: 1, medal: require('@/assets/points-program/medal_bronze.svg'), name: 'Bronze', multiplier: '1' },
                { id: 2, medal: require('@/assets/points-program/medal_prata.svg'), name: 'Prata', multiplier: this.silverMultiplier },
                { id: 3, medal: require('@/assets/points-program/medal_ouro.svg'), name: 'Ouro', multiplier: this.goldMultiplier }
            )
        }
    },
    data: () => ({
        voucherObjectLocal: {},
        confirmObjectLocal: {},
        rulesDialog: false,
        rescueConfirmDialog: false,
        rescueInstructionDialog: false,
        rankingDetailDialog: false,
        rankingObject: {},
        expiringObject: {},
        rankingInfoLocal: {},
        colorRanking: '',
        currentPercent: 0,
        currentMedal: '',
        silverMultiplier: 0,
        goldMultiplier: 0,
        rankingEnabled: false
    }),
    created() {
        this.getInfoRankingOfMultiplier()
        this.getRankingInfo()
        this.getExpiringPoints()
    },
    methods: {
        rescueRoutine(voucherObject) {
            switch(this.currentCompany.integrated) {
                case true: {
                    this.openConfirmModal( voucherObject )
                    break;
                }
                case false: {
                    this.openInstructionModal( voucherObject )
                    break;
                }
                default: {
                    break;
                }
            }
        },
        openConditionsModal(){
            this.rulesDialog = true
        },
        openConfirmModal(param){
            if(this.currentCompany.remainingPoints >= param.pointsToRedeem) {
                this.confirmObjectLocal = param
                this.rescueConfirmDialog = true
            }else {
                this.$toasted.show( 'Pontuação insuficiente.', { type: 'info' })
            }
        },
        openInstructionModal(param) {
            if(this.currentCompany.remainingPoints >= param.pointsToRedeem) {
                this.voucherObjectLocal = param
                this.rescueInstructionDialog = true
            }else {
                this.$toasted.show( 'Pontuação insuficiente.', { type: 'info' })
            }            
        },
        getRankingInfo() {
            getRankingByCompanyIdAndCurrentContactId(this.currentCompany.id)
                .then(success => {
                        this.rankingObject = success.data
                        this.setRankingColorAndMedal(this.rankingObject.ranking)
                        this.setCurrentPercent(this.rankingObject)
                    }
                )
                .catch( error => {
                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        getInfoRankingOfMultiplier() {            
            getCompanyLoyaltyByCompanyId(this.currentCompany.id)
                .then(success => {
                        this.rankingEnabled = success.data.gamification.enabled
                        this.silverMultiplier = success.data.gamification.parameters.tiers[1].tierMultiplier
                        this.goldMultiplier = success.data.gamification.parameters.tiers[2].tierMultiplier
                        this.rankingInfoLocal = success.data
                    }
                )
                .catch( error => {
                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        getExpiringPoints() {
            getExpiringPointsByCompanyIdAndCurrentContactId(this.currentCompany.id)
                .then(success => {
                        this.expiringObject = success.data
                    }
                )
                .catch( error => {
                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        getDateByTimeStamp( data ){
            if(data == undefined || data == null ) return
            let moment = new Date(data)
            let formatted =  moment.toLocaleDateString("pt-BR")
            return formatted;
        },
        setRankingColorAndMedal(currentRanking) {
            if(currentRanking == null ) return
            
            if( currentRanking.toLowerCase() == 'bronze' ) {
                this.colorRanking = '#8D7365'
                this.currentMedal = require('@/assets/points-program/medal_bronze.svg')
            } 
            else if( currentRanking.toLowerCase() == 'prata' ) {
                this.colorRanking = '#C7C7C7'
                this.currentMedal = require('@/assets/points-program/medal_prata.svg')
            }
            else if( currentRanking.toLowerCase() == 'ouro' ) {
                this.colorRanking = '#F5D141'
                this.currentMedal = require('@/assets/points-program/medal_ouro.svg')
            }
        },
        setCurrentPercent( rankingInfo ) {
            if(rankingInfo.total !== null && rankingInfo.nextMinValue !== null) {
                var percent = 100 * rankingInfo.total / rankingInfo.nextMinValue
                this.currentPercent = parseInt(percent.toString(), 10)
                
                if( this.currentPercent > 100 ) {
                    this.currentPercent = 100
                }
            }
        },
        openRankingDetail() {
            this.rankingDetailDialog = true
        }
    }
}
</script>

<style scoped>
::v-deep .v-slide-group__prev {
    min-width: 10px;
    padding-right: 6px;
    color: var(--cor--preta) !important;
}
::v-deep .v-slide-group__next {
    min-width: 10px;
    padding-left: 6px;
    color: var(--cor--preta) !important;
}
.vcol__vslidegroup {
    padding-top: 12px;
}
.vcol_div__numberofpoints {
    padding-left: 10px;
    padding-top: 4px;
    font-weight: bold;
}
.cards-div{
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 10px 10px 10px 0px;
}
.shop-card{
    margin-right: 15px;
    margin-bottom: 6px;
    margin-left: 1px;
}

.voucher__card__title {
  font-weight: 600;
  color: var(--cor--preta);
  font-size: 15px;
}
.monetary{
    font-size: 10px;
}
.ranking-bond{
    color: var(--cor--preta);
    font-size: 13px;
    letter-spacing: 2px;
    text-transform: uppercase;
}
.rescue-day{
    text-align: center;
    margin-top: 10px;
    font-size: 13px;
    width: 80%;
}
.btns-bottom{
    width: 40%;
    max-width: 208px;
    min-width: 208px !important;
    margin-top: 15px;
    font-size: 18px;
    font-weight: 600;
}
.background-yellow {
  background-color: var(--cor--amarelo);
}
.voucher__card__image__container {
  min-height: 140px;
  max-height: 140px;
  display: flex;
  flex: auto;
  align-items: center;
  justify-content: center;
}
.div__emptyimg {
    width: 250px;
}
.teste {
    filter: invert(37%) sepia(20%) saturate(29%) hue-rotate(314deg) brightness(93%) contrast(80%);
}
.vcol_vcard_cardtext__ranking--title {
    font-weight: bold;
    color: var(--cor--preta)
}
.card-custom {
    margin: 12px 0px;
    min-width: 50px;
}
.vcol_span__ranking--percent {
    font-size: 12px;
    margin: 6px 0px;
    color: var(--cor--cinzaApp);
}
.progress-circular_divexp__exp {
    color: var(--cor--preta);
    font-weight: 800;
    font-size: 18px;
    margin-right: 6px;
}
.custom--exp {
    color: var(--cor--preta);
    font-size: 13px;
    letter-spacing: 1.5px;
}
.ranking-bonus {
    color: var(--cor--preta);
    font-size: 10px;
    margin-top: 6px;
}
</style>